import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QRChipOutline } from '@base/src/app/models/qr-chip-outline.model';

@Component({
  selector: 'qr-chip-outline',
  templateUrl: './chip-outline.component.html',
  styleUrls: ['./chip-outline.component.scss'],
})
export class ChipOutlineComponent {
  @Input() config!: QRChipOutline;
  @Input() selected = false;
  @Input() isDisabled = false;
  @Output() selectedChange = new EventEmitter<boolean>();

  toggle(): void {
    if (this.isDisabled) {
      return;
    }
    this.selectedChange.emit(!this.selected);
  }
}
